export default __webpack_public_path__ + "static/macbook2-ca106280809ceb9a2a5a49a44258233a.png";